"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function Bezier(startPoint, control1, control2, endPoint) {
  this.startPoint = startPoint;
  this.control1 = control1;
  this.control2 = control2;
  this.endPoint = endPoint;
}

// Returns approximated length.
Bezier.prototype.length = function getCurveLength() {
  var steps = 10;
  var length = 0;
  var px = void 0;
  var py = void 0;

  for (var i = 0; i <= steps; i += 1) {
    var t = i / steps;
    var cx = this.point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
    var cy = this.point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
    if (i > 0) {
      var xdiff = cx - px;
      var ydiff = cy - py;
      length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
    }
    px = cx;
    py = cy;
  }

  return length;
};

Bezier.prototype.point = function calculatePoint(t, start, c1, c2, end) {
  return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
};

exports.default = Bezier;
//# sourceMappingURL=bezier.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-another-signature-pad/dist/bezier.js
// module id = 1108
// module chunks = 0